module.exports = __webpack_public_path__ + "files/SPIADI - Synthèse des recommandations - cathéters centraux.92f7362a9c8e0acc0566d70cae129235.pdf";